import { Lookup } from "../Lookup";
import LookupTypes from "../LookupTypes";
import { SearchTerm } from "../search/SearchTerm";
import { TableColumn } from "../table/TableColumn";

export const extendColumnDefinition = (columns: TableColumn[], extender: string): TableColumn[] => {
    return columns.map((column) => {
        return {
            ...column,
            sortByName: column.sortByName ? `${extender}.${column.sortByName}` : column.sortByName,
            searchOnName: column.searchOnName ? `${extender}.${column.searchOnName}` : column.searchOnName,
            lookupName: column.lookupName ? `${extender}.${column.lookupName}` : column.lookupName,
        }
    });
}

export const extendSearchColumn = (searchColumns: SearchTerm[], extender: string): SearchTerm[] => {
    return searchColumns.map(searchColumn => {
        return {
            ...searchColumn,
            searchOnName: `${extender}.${searchColumn.searchOnName}`,
        }
    })
}

export const hideColumns = (columns: TableColumn[], columnsToHide: string[]): TableColumn[] => {
    return columns.map(column => {
        return {
            ...column,
            active: columnsToHide.indexOf(column.accessor) !== -1 ? false : column.active
        }
    })
}

export const removeColumns = (columns: any[], columnsToRemoved: string[]): any[] => {
    return columns.filter((column) => !columnsToRemoved.includes(column.accessor));
}

/**
 * Marks the specified columns as filter-only: hidden from the table display and column chooser,
 * but still available as filter options. Useful when child/detail columns need to participate
 * in filtering on the parent table without being rendered as visible columns.
 */
export const makeFilterOnlyColumns = (columns: TableColumn[], filterOnlyAccessors: string[]): TableColumn[] => {
    return columns.map(column => {
        return filterOnlyAccessors.includes(column.accessor)
            ? { ...column, active: false, isFilterOnlyColumn: true }
            : column;
    });
}

export const extendLookups = (lookup: Lookup[], extendUsing: string): Lookup[] => {
    return lookup.map((current) => {
        if (current.name === LookupTypes.days) {
            return current;
        }
        return {
            ...current,
            name: extendUsing + '.' + current.name,
        }
    })
};

/**
 * Hide lookup for specific columns by accessor name
 */
export const hideLookups = (columns: TableColumn[], columnsToHideLookup: string[]): TableColumn[] => {
    return columns.map(column => {
        if (columnsToHideLookup.includes(column.accessor)) {
            return {
                ...column,
                hideLookup: true
            };
        }
        return column;
    });
};

